import { useEffect } from "react";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

// Hybrid sticky: hide on scroll-down past the navbar height, reveal on any
// scroll-up. Always visible at the top of the page.
const DELTA_THRESHOLD = 4;

export const useWindowScroll = () => {
  useEffect(() => {
    let rafId = 0;
    let lastY = window.scrollY;
    let wasHidden = false;

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        const navHeight = rootComponentsStore.topBarHeight.get();
        const currentY = window.scrollY;
        const delta = currentY - lastY;

        let hidden = wasHidden;
        if (currentY <= navHeight) {
          hidden = false;
        } else if (delta > DELTA_THRESHOLD) {
          hidden = true;
        } else if (delta < -DELTA_THRESHOLD) {
          hidden = false;
        }

        if (hidden !== wasHidden) {
          wasHidden = hidden;
          rootComponentsStore.isTopBarHidden.set(hidden);
        }
        lastY = currentY;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
};
